import axios from '../config/axiosConfig';

export async function getUserByToken(token) {
  try {
    const response = await axios.get(`/api/auth/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Impossibile ottenere le informazioni sull'utente");
  }
}